import { ProjectStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export const ProjectStatus = {
  Draft: {
    value: ProjectStatusEnum.Draft,
    description: 'The project have not started yet',
    sort: 0,
    tone: StatusToneEnum.Draft,
  },
  InProgress: {
    value: ProjectStatusEnum.InProgress,
    description: 'The project has started',
    sort: 1,
    tone: StatusToneEnum.InProgress,
  },
  Complete: {
    value: ProjectStatusEnum.Complete,
    description: 'The project is done.',
    sort: 2,
    tone: StatusToneEnum.Active,
  },

  Cancelled: {
    value: ProjectStatusEnum.Cancelled,
    description: 'The project has been cancelled.',
    sort: 3,
    tone: StatusToneEnum.Cancelled,
  },
}
